import {Injectable} from "@angular/core";
import { AngularFireDatabase } from'angularfire2/database/database';
import {Http, Headers} from "@angular/http";

@Injectable()

export class LugaresService{
  //PASA USAR HTTP 
  API_ENDPOINT = "https://gyc-plaza.firebaseio.com";

lugares:any = [];
  /*lugares:any= [
  {id:1, plan:'pagado', cercania:1, distancia:1, active: true, name:'Floristeria El Jardin', descripcion: 'de este negocio sera colocada mas adelante. gracias por su comprencion.'},
  {id:2, plan:'gratuito', cercania:1, distancia:1.8, active: true, name:'Veterinaria Mi Angelito', descripcion: 'de este negocio sera colocada mas adelante. gracias por su comprencion.'},
  {id:3, plan:'gratuito', cercania:2, distancia:5, active: true, name:'Supermercado Ole', descripcion: 'de este negocio sera colocada mas adelante. gracias por su comprencion.'},
  {id:4, plan:'gratuito', cercania:3, distancia:10, active: false, name:'CyberCaffe Geeks', descripcion: 'de este negocio sera colocada mas adelante. gracias por su comprencion.'},
  {id:5, plan:'pagado', cercania:2, distancia:35, active: true, name:'Restaurante La Casita', descripcion: 'de este negocio sera colocada mas adelante. gracias por su comprencion.'},
  {id:6, plan:'gratuito', cercania:3, distancia:120, active: true, name:'Ferreteria Bellon', descripcion: 'de este negocio sera colocada mas adelante. gracias por su comprencion.'}];*/
  
  constructor(private afDB:AngularFireDatabase, private http:Http){ }
//
	public getLugares(){
		return this.afDB.list('lugares/');

    //USAR HTTP con el Metodo GET
    //return this.http.get(this.API_ENDPOINT+'/lugares.json');
	}

  public getLugar(id){
   return this.afDB.object('lugares/'+ id);
  }

	public buscarLugar(id){
	return this.lugares.find((lugar)=> lugar.id == id);
  }

  public guardarLugar(lugar){
    //SOCKET
    lugar.id = new Date().getTime();
    return this.afDB.database.ref('lugares/'+ lugar.id).set(lugar);
    

    //USAR HTTP POST
    /*
    const headers = new Headers({"Content-Type":"application/json"});
    return this.http.post(this.API_ENDPOINT+'/lugares.json', lugar, {headers:headers}).subscribe();
  */
  }

    public editarLugar(lugar){
    this.afDB.database.ref('lugares/'+ lugar.id).set(lugar);
  }

  public obtenerGeoData(direccion){
// URL de PRUEBA: http://maps.google.com/maps/api/geocode/json?address=8-43+bermudez+72f,+La%20Romana,Republica%20Dominicana
 return this.http.get('http://maps.google.com/maps/api/geocode/json?address='+direccion)
  }

};




// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/services/lugares.service.ts